import { CartographyServiceResourceEventEnum } from '../../module/cartography/enum/cartography-service-resource-event.enum';

export class MapBbxLoadGroups {
  static readonly type = '[MapBbx] Load Groups';
}

export class MapBbxLoadBbx {
  static readonly type = '[MapBbx] Load Bbx';
}

export class MapBbxDeleteBbx {
  static readonly type = '[MapBbx] Delete Bbx';
}

export class MapBbxDeleteGroups {
  static readonly type = '[MapBbx] Delete Groups';
}

export class MapBbxLoadPositions {
  static readonly type = '[MapBbx] Load Positions';
}

export class MapBbxDeletePositions {
  static readonly type = '[MapBbx] Delete Positions';
}

export class MapBbxLoadStatus {
  static readonly type = '[MapBbx] Load Status';
}

export class MapBbxDeleteStatus {
  static readonly type = '[MapBbx] Delete Status';
}

export class MapBbxLoadGroupsAndResources {
  static readonly type = '[MapBbx] Load Groups and Resources';
}

export class MapBbxLoadDataModel {
  static readonly type = '[MapBbx] Load Data Model Bbx';
}

export class MapBbxDeleteDataModel {
  static readonly type = '[MapBbx] Delete Data Model';
}

export class MapBbxClearAll {
  static readonly type = '[MapBbx] Clear All';
}

export class MapBbxEvent {
  static readonly type = '[MapBbx] Event';
  constructor(public payload: CartographyServiceResourceEventEnum) {}
}
